<template>
  <div class="upload-box">
    <img :src="value" :style="{'width':width+'px',height:height+'px'}">
    <Upload
      :show-upload-list="false"
      :multiple="false"
      type="drag"
      action="/"
      class="upload-btn"
      :before-upload="handleUpload"
    >
      <Button type="primary" ghost class="btn">更换图片</Button>
    </Upload>
  </div>
</template>

<script>
import { uploadFile } from "@/api/httpList";
export default {
  components: {
  },
  mixins:[],
  props: ['value','width','height'],
  data() {
    return {
      dic:{},
      img:"",
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    handleUpload(file) {
      const reg = /\.(png|jpg|jpeg|gif|bmp)$/;
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(`上传格式不正确，请上传jpg/jpeg/gif/bmp/png格式文件`);
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then(res => {
        this.$emit("input", res.data[0].path);
      });
      return false;
    }
  },

};
</script>
<style lang="scss" scoped>
.upload-box {
  display: flex;
  align-items: flex-end;
  /deep/ .ivu-upload {
    border: 0;
    display: inline-block;
    vertical-align: top;
    padding: 2px;
    transform: translateY(2px);
  }
  .btn {
    margin-left: 20px;
  }
}

</style>
